import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, Navigate } from 'react-router-dom';
import { dgWithReducer, useFirstRender } from 'dg-utils';
import loginReducer from './loginReducer.mjs';
import { S as Spinner } from './spinner-bf1b67d8.js';
import { checkIsLoggedIn } from './loginActions.mjs';
import '@babel/runtime/helpers/defineProperty';
import './types-0b7e03a3.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '@babel/runtime/helpers/inherits';
import '@babel/runtime/helpers/possibleConstructorReturn';
import '@babel/runtime/helpers/getPrototypeOf';

var _excluded = ["component"];

function ProtectedRoute(props) {
  var navigate = useNavigate();
  var firstRender = useFirstRender();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      isAuthenticated = _useState2[0],
      setIsAuthenticated = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  useEffect(function () {
    // Set the component to loading
    setIsLoading(true);
    props.checkIsLoggedIn().then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
        var _props$onLoggedIn;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return props === null || props === void 0 ? void 0 : (_props$onLoggedIn = props.onLoggedIn) === null || _props$onLoggedIn === void 0 ? void 0 : _props$onLoggedIn.call(props, response === null || response === void 0 ? void 0 : response.user);

              case 2:
                // Mark the user as authenticated if no errors were encountered
                setIsAuthenticated(true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (error) {
      alert("Access Denied");
      setIsAuthenticated(false);
    });
  }, []); // When the authentication flag changes, stop loading

  useEffect(function () {
    // Set loading to false
    if (!firstRender) {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  var Component = props.component,
      componentProps = _objectWithoutProperties(props, _excluded);

  var extendedComponentProps = Object.assign({}, {
    navigate: navigate
  }, componentProps);
  console.log("Extended props", extendedComponentProps);
  return isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : isAuthenticated ? /*#__PURE__*/React.createElement(Component, extendedComponentProps) : /*#__PURE__*/React.createElement(Navigate, {
    to: "/"
  });
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    checkIsLoggedIn: function checkIsLoggedIn$1() {
      return dispatch(checkIsLoggedIn());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.loggedInUser
  };
};

var protectedRoute = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(ProtectedRoute, "loggedInUser", loginReducer));

export { protectedRoute as default };
